export const getSource = source =>{
    let d = {
        autoagendamientoapp: {id:2},
        autoagendamientocat: {id:6},
        flujoallianz: {id:3},
        manual: {id:1},
        webike: {id: 4},
        autoagendamientoappallianz: {id: 8},
        autoagendamientovardi: {id: 10},
        autoagendamientonuevoeps: {id: 11}
    }

    return d[source] || null;
}